import type { Overlay, StatHelpTopic } from "../../domain/types/index.js";

export type { StatHelpTopic };

export const STAT_HELP_TOPICS = ["progress", "deadline", "fatigue", "block"] as const satisfies readonly StatHelpTopic[];

export type StatHelpCopy = {
  title: string;
  body: string[];
};

export const STAT_HELP: Record<StatHelpTopic, StatHelpCopy> = {
  progress: {
    title: "進捗",
    body: [
      "進捗は、このプロジェクトを終わらせるための仕事量です。右の数字が要求量に届くと、プロジェクトは成功です。",
      "労働者カードは、施策フェーズを終了したときにまとめて進捗を出します。",
    ],
  },
  deadline: {
    title: "期限",
    body: [
      "期限は、今のフェーズを含む残りのフェーズ数です。丸が1つなら、今のフェーズが最後です。",
      "期限内に進捗が満タンにならないと、プロジェクトは失敗します。",
    ],
  },
  fatigue: {
    title: "疲労",
    body: [
      "疲労は組織の余裕です。0から始まり、上限に達すると組織崩壊でゲームオーバーです。上限は通常10、メンタル研修なら12です。",
      "プロジェクトに成功しても、原則として減りません。休日で戻せます。",
    ],
  },
  block: {
    title: "防御",
    body: [
      "防御は、そのフェーズの負荷から疲労を減らす盾です。交渉術があれば、進捗戻しも同じ値だけ軽減します。",
      "負荷を受けたあと、残っていても消えます。次のフェーズには持ち越せません。",
    ],
  },
};

const PREFIX = "statHelp.";

export function statHelpOverlay(topic: StatHelpTopic): Overlay {
  return `${PREFIX}${topic}`;
}

export function topicFromOverlay(overlay: Overlay): StatHelpTopic | null {
  if (!overlay.startsWith(PREFIX)) return null;
  const topic = overlay.slice(PREFIX.length);
  return STAT_HELP_TOPICS.find((item) => item === topic) ?? null;
}

export function statHelpLabel(topic: StatHelpTopic): string {
  return `${STAT_HELP[topic].title}の説明`;
}
